import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        title: {
            type: [String, Object],
            default: ''
        },
        description: {
            type: [String, Object],
            default: ''
        },
        avatar: {
            type: String,
            default: ''
        },
        owner: {
            type: Boolean,
            default: false
        }
    }
});
